import { gql } from '@apollo/client';

export const GET_RESTRICTED_SKU_IMPORT_LOGS = gql(/* GraphQL */ `
    query GetRestrictedSkuImportLogs($input: GetImportLogsInput!) {
        getManualImportLogs(input: $input) {
            total
            logs {
                id
                fileName
                s3Key
                status
                recordsProcessed
                createdAt
                completedAt
                createdBy {
                    id
                    firstName
                    lastName
                }
            }
        }
    }
`);
